import * as actionTypes from "./types";
import * as authService from "@/auth";
import storePersist from "@/redux/storePersist";
import { roles } from "@/utils/constant";
import { useSelector } from "react-redux";
import { selectAuth } from "./selectors";
import store from "../store";

const state = store?.getState();
const auth = state?.auth;

export const login = (loginAdminData) => async (dispatch) => {
  dispatch({
    type: actionTypes.LOADING_REQUEST,
    payload: { loading: true },
  });
  const data = await authService.login(loginAdminData);

  if (data.success === true) {
    storePersist.set("remember", loginAdminData?.remember);
    authService.localStorage.set(data?.result?.token);
    if (!loginAdminData?.remember) {
      authService.sessionStorage.set(data?.result?.token);
    }
    // if (
    //   !data?.result?.user?.hasAssignedShop &&
    //   data?.result?.user?.role !== roles.ADMIN &&
    //   data?.result?.user?.role !== roles.APPRAISALWRITER
    // ) {

    if (
      !data?.result?.user?.hasAssignedShop &&
      data?.result?.user?.role !== roles.ADMIN
    ) {
      authService.logout();
      dispatch({
        type: actionTypes.LOGOUT_SUCCESS,
      });
      window.location.href = "/waiting-page";
      return;
    }
    if (data?.result?.user?.role === roles.SHOPOWNER) {
      dispatch(getShopInfoByShopOwner({ poc: data?.result?.user?.id })).then(
        (res) => {
          dispatch(checkIfShopIsAssignedToUser(res, data));
        }
      );
    } else if (data?.result?.user?.role === roles.APPRAISALWRITER) {
      dispatch(
        getShopInfoByShopOwner({ appraisalWriter: data?.result?.user?.id })
      ).then((res) => {
        dispatch(checkIfShopIsAssignedToUser(res, data));
      });
    } else {
      dispatch({ type: actionTypes.WAITING_FALSE });
      if (data?.isLoggedIn) {
        dispatch({
          type: actionTypes.LOGIN_SUCCESS,
          payload: data.result,
        });
      }
      const authValue = {
        current: data?.result,
        loading: false,
        isLoggedIn: true,
      };
      storePersist.set("auth", authValue);
      window.location.href = "/appraisal";
    }
  } else {
    dispatch({
      type: actionTypes.FAILED_REQUEST,
      payload: data,
    });
  }
};

export const logout = (navigate) => async (dispatch) => {
  const _id = auth?.current?.user?.id;
  authService.logoutUser(_id);
  dispatch({
    type: actionTypes.LOGOUT_SUCCESS,
  });
  navigate("/login");
};

export const getShopInfoByShopOwner = (params) => async (dispatch) => {
  const shopInfo = await authService.fetchShopByOwner(params);
  if (shopInfo?.success) {
    dispatch({ type: actionTypes.SHOP_PROFILE, payload: shopInfo?.data });
    return {
      success: true,
      shopProfile: shopInfo?.data,
    };
  }
  if (shopInfo?.noShopData) {
    return {
      data: shopInfo?.data,
      noShopData: true,
    };
  }
};

export const getAllNotificationsByUser = (_id) => async (dispatch) => {
  const result = await authService.fetchNotificationsByUser(_id);
  return {
    success: true,
    userNotifications: result?.data?.notifications,
  };
};

export const checkIfShopIsAssignedToUser = (res, data) => async (dispatch) => {
  // if (res?.noShopData && Object.keys(res?.data).length === 0) {
  //   authService.logout();
  //   dispatch({
  //     type: actionTypes.LOGOUT_SUCCESS,
  //   });
  //   window.location.href = "/waiting-page";
  // } 
  // if (res?.success && Object.keys(res?.shopProfile).length > 0) {
  if (data?.isLoggedIn) {
    dispatch({
      type: actionTypes.LOGIN_SUCCESS,
      payload: data.result,
    });
  }
  dispatch({ type: actionTypes.WAITING_FALSE });
  const authValue = {
    current: data?.result,
    loading: false,
    isLoggedIn: true,
    shopProfile: res?.shopProfile,
  };
  storePersist.set("auth", authValue);
  window.location.href = "/appraisal";
  // }
};

export const addNotification = (data) => async (dispatch) => {
  dispatch({
    type: actionTypes.ADD_NOTIFICATIONS,
    payload: [data],
  });
};
